import type { LegacyConversationCardSkeletonProps } from 'src/modules/communications/types/legacy-conversation-card.type';

/** Shows the existing loading placeholder used before conversation cards load. */
export const LegacyConversationCardSkeleton: React.FC<
  LegacyConversationCardSkeletonProps
> = ({ className = '', layout = 'list' }) => {
  const previewHeightClassName = layout === 'pipeline' ? 'h-8' : 'h-4';

  return (
    <div
      className={`animate-pulse rounded-lg border border-neutral-200 bg-white px-3 py-2.5 ${
        layout === 'pipeline' ? 'min-h-[104px]' : 'min-h-[84px]'
      } ${className}`}
    >
      <div className="flex h-full flex-col gap-1.5">
        <div className="flex items-center justify-between gap-2">
          <div className="flex min-w-0 flex-1 items-center gap-2">
            <div className="h-7 w-7 flex-shrink-0 rounded-full bg-neutral-100" />
            <div className="h-4 w-32 rounded bg-neutral-100" />
          </div>
          <div className="flex shrink-0 items-center gap-1.5">
            <div className="h-2.5 w-9 rounded bg-neutral-100" />
            <div className="h-7 w-7 rounded-md bg-neutral-100" />
          </div>
        </div>

        <div className="flex items-start gap-1.5">
          <div className="mt-0.5 h-4 w-8 flex-shrink-0 rounded bg-neutral-100" />
          <div className={`min-w-0 flex-1 ${previewHeightClassName}`}>
            <div className="h-3 w-full rounded bg-neutral-100" />
            {layout === 'pipeline' && (
              <div className="mt-1 h-3 w-4/5 rounded bg-neutral-100" />
            )}
          </div>
        </div>

        <div className="flex items-center gap-2">
          <div className="flex min-w-0 flex-1 items-center gap-2">
            {layout === 'list' && (
              <div className="h-5 w-20 rounded-full bg-neutral-100" />
            )}
            <div className="h-5 w-16 rounded-full bg-neutral-100" />
          </div>
          <div className="ml-auto h-3 w-20 rounded bg-neutral-100" />
        </div>
      </div>
    </div>
  );
};
